import React, { useState } from "react";
import { FaLock, FaLockOpen } from "react-icons/fa";
import { FcLike, FcDislike } from "react-icons/fc";
import { BiTransfer } from "react-icons/bi";
import { getAlternatives } from "../api/diet";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "../misc/common.css";
import { getMealName, getUnit } from "../misc/utils";
import RichNut from "./RichNut";
import LimitBadge from "./LimitBadge";

function DietMeal(props) {
    const [showAltFood, setShowAltFood] = useState(false);
    const [alternatives, setAlternatives] = useState([]);
    //const [portionChanged, setShowAltFood] = useState(false);
    //const [minChanged, setShowAltFood] = useState(false);
    //const [maxChanged, setShowAltFood] = useState(false);
    const onOpenModal = () => setShowAltFood(true);
    const onCloseModal = () => setShowAltFood(false);

    let minChanged = false;
    let maxChanged = false;
    let portionChanged = false;

    let totals = getTot();
    function getTot() {
        let totCarbs = 0,
            totProts = 0,
            totFats = 0,
            totCals = 0,
            totFib = 0,
            totSod = 0;

        for (var i = 0; i < props.foodList.length; i++) {
            totCarbs += props.foodList[i].carbs;
            totProts += props.foodList[i].prots;
            totFats += props.foodList[i].fats;
            totCals += props.foodList[i].cals;
            totFib += props.foodList[i].fib;
            totSod += props.foodList[i].sod;
        }
        return {
            carbs: totCarbs.toFixed(2),
            prots: totProts.toFixed(2),
            fats: totFats.toFixed(2),
            cals: totCals.toFixed(2),
            fib: totFib.toFixed(2),
            sod: totSod.toFixed(2)
        };
    }

    async function showAlternatives(food) {
        setAlternatives(await getAlternatives(food, 1));
        onOpenModal();
    }

    return (
        <>
            <tr style={{ fontWeight: "bold" }}>{/* Meal title */}
                <td colSpan="3">{getMealName(props.mealTime)}</td>
                <td colSpan={props.showAllData ? "9" : "6"} className="tip">
                    {props.mealCtrl ? props.mealCtrl.message : ""}
                </td>
            </tr>
            {props.foodList.map(food => {
                return (
                    <tr key={food.foodId}>
                        <td />
                        <td>{/* disable button */}
                            <button className={food.omit ? "" : "showOnHover"} onClick={() => props.onOmitClicked(food)}>
                                {food.omit ? <FcDislike /> : <FcLike />}
                            </button>
                        </td>
                        <td className={food.omit ? "omit" : ""}>{/* rich legend */}
                            {food.foodName + " "}
                            <RichNut data={food} />
                        </td>
                        <td>
                            {food.omit ? (
                                "-"
                            ) : food.lockedPortion ? (
                                /* locked portion input */
                                <input
                                    type="text"
                                    value={food.dietPortion}
                                    size="5"
                                    onChange={event => props.onPortionChange(event, food, 1)}
                                    onKeyUp={event => {
                                        portionChanged = true;
                                        if (event.keyCode === 13) {
                                            portionChanged = false;
                                            props.onChangeEnd(event, food, 1);
                                        }
                                    }}
                                    onBlur={event => {
                                        if (portionChanged) {
                                            portionChanged = false;
                                            props.onChangeEnd(event, food, 1);
                                        }
                                    }}
                                />
                            ) : (/* autogenerated portion */
                                <>
                                    {`${food.dietPortion} ${getUnit(food.portionUnit)} `} <LimitBadge data={food} />{" "}
                                </>
                            )}
                            {food.omit ? (
                                <span />
                            ) : (/* lock button */
                                <button
                                    className={food.lockedPortion && !food.omit ? "" : "showOnHover"}
                                    onClick={() => props.onLockPortionClicked(food)}
                                >
                                    {food.lockedPortion ? <FaLock /> : <FaLockOpen />}
                                </button>
                            )}
                            &nbsp;
                            <div className={food.lockedPortion || food.omit ? "hide" : "showOnHover"}>{/* Min & Max inputs */}
                                &nbsp; Min:&nbsp;
                                <input
                                    type="text"
                                    value={food.minPortion}
                                    size="4"
                                    onChange={event => props.onPortionChange(event, food, 2)}
                                    onKeyUp={event => {
                                        minChanged = true;
                                        if (event.keyCode === 13) {
                                            minChanged = false;
                                            props.onChangeEnd(event, food, 2);
                                        }
                                    }}
                                    onBlur={event => {
                                        if (minChanged) {
                                            minChanged = false;
                                            props.onChangeEnd(event, food, 2);
                                        }
                                    }}
                                />
                                &nbsp; Max:&nbsp;
                                <input
                                    type="text"
                                    value={food.maxPortion}
                                    size="4"
                                    onChange={event => props.onPortionChange(event, food, 3)}
                                    onKeyUp={event => {
                                        maxChanged = true;
                                        if (event.keyCode === 13) {
                                            maxChanged = false;
                                            props.onChangeEnd(event, food, 3);
                                        }
                                    }}
                                    onBlur={event => {
                                        if (maxChanged) {
                                            maxChanged = false;
                                            props.onChangeEnd(event, food, 3);
                                        }
                                    }}
                                />
                            </div>
                        </td>
                        <td>{/* alternatives button */}
                            <button onClick={() => showAlternatives(food)}>
                                <BiTransfer />
                            </button>
                            <Modal open={showAltFood} onClose={onCloseModal} center>
                                <h2>Posible comida alterna:</h2>
                                <table>
                                    <tbody>
                                        {alternatives.map(record => {
                                            return (
                                                <tr>
                                                    <td>{record}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </Modal>
                        </td>{/* food nutrient's data */}
                        <td>{food.carbs.toFixed(2)}</td>
                        <td>{food.fats.toFixed(2)}</td>
                        <td>{food.prots.toFixed(2)}</td>
                        {props.showAllData && (
                            <>
                                <td>{food.cals.toFixed(2)}</td>
                                <td>{food.fib.toFixed(2)}</td>
                                <td>{food.sod.toFixed(2)}</td>
                            </>
                        )}
                        <td>{/* delete button */}
                            <input type="button" onClick={event => props.onDeleteClicked(food)} className="btn btn-danger btn-sm" value="Borrar" />
                        </td>
                    </tr>
                );
            })}
            <tr style={{ fontWeight: "bold", backgroundColor: "#8798a9", color: "#fff" }}>
                <td colSpan="5">-</td>
                <td>{getTot().carbs}</td>
                <td>{getTot().fats}</td>
                <td>{getTot().prots}</td>
                {props.showAllData && (
                    <>
                        <td>{totals.cals}</td>
                        <td>{totals.fib}</td>
                        <td>{totals.sod}</td>
                    </>
                )}
                <td />
            </tr>
        </>
    );
}
export default DietMeal;
